import { useState, useEffect } from "react"

function useKeyboardNavigation() {
  const [isKeyboardNavigation, setIsKeyboardNavigation] = useState(false)

  useEffect(() => {
    const handleKeyDown = () => setIsKeyboardNavigation(true)
    const handleMouseDown = () => setIsKeyboardNavigation(false)

    window.addEventListener("keydown", handleKeyDown)
    window.addEventListener("mousedown", handleMouseDown)

    // Cleanup event listeners on unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown)
      window.removeEventListener("mousedown", handleMouseDown)
    }
  }, [])

  return isKeyboardNavigation
}

export default useKeyboardNavigation
